/**
 * 缓存说明:工单相关的组
 */
import vm from '@/cache/storeTools.js'
import orderGroupApi from '@/components/api/order/orderGroupApi.js'

var basestate = {
	//根据groupType 查询出来的组列表 workerGroup.vue
	groups: {},
	//组已绑定的角色列表
	groupUserList: {},
	orderGroupTree: undefined,
	priorityList: [{
		name: '紧急',
		value: 'Emergent'
	}, {
		name: '高',
		value: 'High'
	}, {
		name: '标准',
		value: 'Standard'
	}, {
		'name': '低',
		value: 'Low'
	}],
	priorityMatch: {
		Emergent: '紧急',
		High: '高',
		Standard: '标准',
		Low: '低'
	},
	orderDefineList: [{
		name: '所有工单',
		value: 'all'
	}, {
		name: '抄送给我',
		value: 'copyToMe'
	}, {
		name: '我创建的',
		value: 'iCreated'
	}, {
		name: '我负责的',
		value: 'myNode'
	}],
}

var store = new vm.Vuex.Store({
	state: copy(basestate),
	getters: {
		//根据groupType 查询出来的组列表 workerGroup.vue
		getGroupsByGroupType(state, getters) {
			return groupType => {
				if(state.groups[groupType] == undefined) {
					store.commit('getGroupsByGroupType', groupType)
				}
				return state.groups[groupType]
			}
		},
		//找出当前groupid绑定过的角色list
		getUserListByGroupId(state, getters) {
			return groupId => {
				if(state.groupUserList[groupId] == undefined) {
					store.commit('getUserListByGroupId', groupId)
				}
				return state.groupUserList[groupId]
			}
		},
		getOrderGroupTree(state, getters) {
			if(state.orderGroupTree == undefined) {
				store.commit('getOrderGroupTree')
				return undefined
			}
			return state.orderGroupTree
		},
		getPriorityIndex(state) {
			return priorityString => {
				return state.priorityList.findIndex(item => {
					return item.value == priorityString
				})
			}
		},
		getOrderGroupByGroupId(state, getters) {
			return id => {
				if(getters.getOrderGroupTree == undefined) {
					return undefined
				}
				return getters.getOrderGroupTree.find(item => {
					return item.groupId == id
				})
			}
		},
		getPriorityByValue(state, getters) {
			return value => {
				return state.priorityList.find(function(item) {
					return item.value == value
				})
			}
		}
	},
	mutations: {
		clear() {
			//清理缓存
			store.replaceState(copy(basestate))
		},
		getGroupsByGroupType(state, groupType) {},
		getUserListByGroupId(state, groupId) {},
		getOrderGroupTree(state) {
			orderGroupApi.loadTree(list => {
				list.forEach(item=>{
					delete item.next
				})
				vm.Vue.set(state, 'orderGroupTree', list)
			})
		}
	}
})

//对外提供
export default store

/**
 * 需要分页的内容,以数组存储全部,取的时候进行分页,
 * 刷新时获取指定页数据,然后合并,重复的数据以新的为准,
 * 可能会导致缺失遗漏,但是有清理缓存就可以了
 */